import { useContext } from "react";
import { AIRoleBuilderTasksContext } from "components/Missions/Roles/AIRoleBuilder/AIRoleBuilderTasksContext";

/**
 * useAIRoleBuilderTasksContext - Hook to access the AI Role Builder queue
 * Throws error if used outside provider
 */
export default function useAIRoleBuilderTasksContext() {
  const context = useContext(AIRoleBuilderTasksContext);

  if (!context) {
    throw new Error("useAIRoleBuilderTasksContext must be used within AIRoleBuilderTasksProvider");
  }

  return context;
}
